<div class="paginator-main-container">
    <p class="paginator-label">{{ label }}</p>

    <div class="tv-container-select-white-round-extensible-low-height width-65px">
        <mat-form-field>
            <mat-select [formControl]="itemsPerPageControl" class="">
                <mat-option *ngFor="let pageSizeOption of pageSizeOptions" [value]="pageSizeOption" class="tv-ns-select-option">
                    {{ pageSizeOption }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <p class="paginator-text">
        <span>{{ lowerCurrentPageItem }} - {{ upperCurrentPageItem }}</span> de <span>{{ length }}</span>
    </p>
    <div class="button-container">
        <button
            class="tv-round-icon-button-icon-small-light-blue right-margin"
            [disabled]="pageIndex === 0"
            (click)="onPreviousNextPageButtonClick(false)">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <button
            class="tv-round-icon-button-icon-small-light-blue"
            [disabled]="pageIndex + 1 === numberOfPages"
            (click)="onPreviousNextPageButtonClick(true)">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
</div>
